const scales = {
  aeolian: {
    name: 'Minor', sequence: [0, 2, 3, 5, 7, 8, 10],
  },
  ionian: {
    name: 'Major', sequence: [0, 2, 4, 5, 7, 9, 11],
  },
  dorian: {
    name: 'Dorian', sequence: [0, 2, 3, 5, 7, 9, 10],
  },
  phrygian: {
    name: 'Phrygian', sequence: [0, 1, 3, 5, 7, 8, 10],
  },
  lydian: {
    name: 'Lydian', sequence: [0, 2, 4, 6, 7, 9, 11],
  },
  mixolydian: {
    name: 'Mixolydian', sequence: [0, 2, 4, 5, 7, 9, 10],
  },
  locrian: {
    name: 'Locrian', sequence: [0, 1, 3, 5, 6, 8, 10],
  },
  chromatic: {
    name: 'Chromatic', sequence: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  },
  acoustic: {
    name: 'Acoustic', sequence: [0, 2, 4, 6, 7, 9, 10],
  },
  algerian: {
    name: 'Algerian', sequence: [0, 2, 3, 5, 6, 7, 9, 10],
  },
  altered: {
    name: 'Altered', sequence: [0, 1, 3, 4, 6, 8, 10],
  },
  pentatonic: {
    name: 'Minoric', sequence: [0, 2, 4, 7, 9],
  },
  wholetone: {
    name: 'Wholetone', sequence: [0, 2, 4, 6, 8, 10],
  },
  blues: {
    name: 'Blues', sequence: [0, 3, 5, 6, 7, 10],
  },
  minorBlues: {
    name: 'Minor Blues', sequence: [0, 2, 3, 5, 6, 7, 8, 10],
  },
  majorBlues: {
    name: 'Major Blues', sequence: [0, 2, 3, 4, 5, 6, 7, 9, 10],
  },
  harmonicMinor: {
    name: 'Harmonic Minor', sequence: [0, 2, 3, 5, 7, 8, 11],
  },
  melodicMinorAsc: {
    name: 'Melodic Minor Asc', sequence: [0, 2, 3, 5, 7, 9, 11],
  },
  melodicMinorDesc: {
    name: 'Melodic Minor Desc', sequence: [0, 2, 3, 5, 7, 8, 10],
  },
  enigmatic: {
    name: 'Enigmatic', sequence: [0, 1, 4, 6, 8, 10, 11],
  },
  doubleHarmonic: {
    name: 'Double Harmonic', sequence: [0, 1, 4, 5, 7, 8, 11],
  },
  persian: {
    name: 'Persian', sequence: [0, 1, 4, 5, 6, 8, 11],
  },
  arabian: {
    name: 'Arabian', sequence: [0, 2, 4, 5, 6, 8, 10],
  },
  japanese: {
    name: 'Japanese', sequence: [0, 1, 5, 7, 8],
  },
  egyptian: {
    name: 'Egyptian', sequence: [0, 2, 5, 7, 10],
  },
  hirajoshi: {
    name: 'Hirajoshi', sequence: [0, 2, 3, 7, 8],
  },
  minorPentatonic: {
    name: 'Minor Pentatonic', sequence: [0, 3, 5, 7, 10],
  },
  majorPentatonic: {
    name: 'Major Pentatonic', sequence: [0, 2, 4, 7, 9],
  },

};

export default scales;



/** WEBPACK FOOTER **
 ** ./src/constants/SCALES.js
 **/